import { render, staticRenderFns } from "./alert-message.vue?vue&type=template&id=1ef4f932&scoped=true&"
import script from "./alert-message.component.ts?vue&type=script&lang=ts&"
export * from "./alert-message.component.ts?vue&type=script&lang=ts&"
import style0 from "./alert-message.vue?vue&type=style&index=0&id=1ef4f932&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef4f932",
  null
  
)

export default component.exports